module.exports = __webpack_public_path__ + "img/portfolio1m.3df42afc.webp";